(function ($, undefined){
    // recaptcha-solved
    jQuery.validator.unobtrusive.adapters.add("recaptchasolved", function (options) {
        options.rules["recaptchasolved"] = options.params;
        if (options.message) {
            options.messages["recaptchasolved"] = options.message;
        }
    });
    jQuery.validator.addMethod("recaptchasolved", function (value, element) {
        return $(element).closest("form").find("textarea[name='g-recaptcha-response']").val() !== "";
    });
}(jQuery));
